import { load } from '@wetransfer/transfer/auth-bundle/helpers/auth0';
import { AppConfig } from '@wetransfer/transfer/core-bundle/config/app-config';

import { CustomWallpaper, WallpaperPreviews } from './types';

export const preallocateCustom = async (body: {
  originalFileName: string;
}): Promise<{
  presignedPutUrl: string;
  assetId: string;
}> => {
  const auth0 = await load();
  const accessToken: string = await auth0.getTokenSilently();

  return (
    await fetch(
      `${AppConfig.customWallpaperServiceUrl}/wallpapers/preallocate`,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      }
    )
  ).json();
};

export const preallocateBranded = async (body: {
  sourceUrl: string;
}): Promise<{
  assetId: string;
}> => {
  const auth0 = await load();
  const accessToken: string = await auth0.getTokenSilently();

  return (
    await fetch(
      `${AppConfig.customWallpaperServiceUrl}/wallpapers/preallocate-branded`,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      }
    )
  ).json();
};

export const preallocateCurated = async (body: {
  imagePath: string;
}): Promise<{
  assetId: string;
}> => {
  const auth0 = await load();
  const accessToken: string = await auth0.getTokenSilently();

  return (
    await fetch(
      `${AppConfig.customWallpaperServiceUrl}/wallpapers/preallocate-curated`,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      }
    )
  ).json();
};

export const uploadFile = async (
  presignedUrl: string,
  body: File
): Promise<200 | number> =>
  (
    await fetch(presignedUrl, {
      method: 'PUT',
      body,
    })
  ).status;

export const processPreviews = async (
  assetId: string
): Promise<201 | number> => {
  const auth0 = await load();
  const accessToken: string = await auth0.getTokenSilently();

  return (
    await fetch(
      `${AppConfig.customWallpaperServiceUrl}/wallpapers/process-previews/${assetId}`,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    )
  ).status;
};

export const checkForPreviews = async (
  assetId: string
): Promise<WallpaperPreviews> => {
  const auth0 = await load();
  const accessToken: string = await auth0.getTokenSilently();

  return (
    await fetch(
      `${AppConfig.customWallpaperServiceUrl}/wallpapers/preview-urls/${assetId}`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
        },
      }
    )
  ).json();
};

export const associateWallpaperWithTransfer = async (
  assetId: string,
  transferId: string
): Promise<200 | number> => {
  const auth0 = await load();
  const accessToken: string = await auth0.getTokenSilently();

  return (
    await fetch(
      `${AppConfig.customWallpaperServiceUrl}/wallpapers/${assetId}`,
      {
        method: 'PATCH',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          transferId,
        }),
      }
    )
  ).status;
};

export const getTransferWallpaper = async (
  transferId: string
): Promise<CustomWallpaper> => {
  return (
    await fetch(
      `${AppConfig.customWallpaperServiceUrl}/wallpapers/${transferId}`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      }
    )
  ).json();
};

export const deleteWallpaper = async (
  assetId: string
): Promise<CustomWallpaper> => {
  const auth0 = await load();
  const accessToken: string = await auth0.getTokenSilently();

  return (
    await fetch(
      `${AppConfig.customWallpaperServiceUrl}/wallpapers/${assetId}`,
      {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
        },
      }
    )
  ).json();
};
